import antdData from 'antd/lib/locale-provider/ru_RU'
import localeData from 'react-intl/locale-data/ru'

const messages = {
  'topBar.typeToSearch': 'Поиск...',
  'topBar.profileMenu.hello': 'Привет',
  'topBar.profileMenu.billingPlan': 'Тарифный план',
  'topBar.profileMenu.role': 'Роль',
  'topBar.profileMenu.email': 'Емайл',
  'topBar.profileMenu.phone': 'Телефон',
  'topBar.profileMenu.editProfile': 'Редактировать профиль',
  'topBar.profileMenu.logout': 'Выйти',
}

export default {
  locale: 'ru-RU',
  antdData,
  localeData,
  messages,
}
